import { render, staticRenderFns } from "./InvioSegnalazione.vue?vue&type=template&id=f95adbea"
import script from "./InvioSegnalazione.vue?vue&type=script&lang=js"
export * from "./InvioSegnalazione.vue?vue&type=script&lang=js"
import style0 from "./InvioSegnalazione.vue?vue&type=style&index=0&id=f95adbea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports